import { UiFlowKey } from "@signalist/shared-types";

import { api } from "@/redux/api";

import {
	SeenUiFlowsResponse,
	SeenUiFlowsResponseSchema,
	UserUiFlowMarker,
	UserUiFlowMarkerSchema,
} from "./userUiFlow.schema";

export const userUiFlowApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSeenUiFlows: builder.query<SeenUiFlowsResponse, void>({
			query: () => ({
				url: "user-ui-flow",
				responseSchema: SeenUiFlowsResponseSchema,
			}),
			providesTags: ["UserUiFlow"],
		}),
		markUiFlowSeen: builder.mutation<UserUiFlowMarker, UiFlowKey>({
			query: (flowKey) => ({
				url: `user-ui-flow/${flowKey}`,
				method: "POST",
				responseSchema: UserUiFlowMarkerSchema,
			}),
			invalidatesTags: ["UserUiFlow"],
		}),
	}),
});

export const { useGetSeenUiFlowsQuery, useMarkUiFlowSeenMutation } = userUiFlowApi;
